import Const from 'constants';
import Action from 'components/organisms/competition-stacking/actions';

const f1PerTeamDriverLimits = {
    useF1PerTeamDriverLimits(use) {
        return {
            type: Const.F1_PER_TEAM_DRIVER_LIMITS_SET_IS_USED,
            use,
        };
    },

    setForTeam(teamName) {
        return {
            type: Const.F1_PER_TEAM_DRIVER_LIMITS_SET_FOR_TEAM,
            teamName,
        };
    },

    setForTeams(teamNames) {
        return {
            type: Const.F1_PER_TEAM_DRIVER_LIMITS_SET_FOR_TEAMS,
            teamNames,
        };
    },
};

export default Object.assign(Action, f1PerTeamDriverLimits);
